import { SVGIconComponent } from './types';

export const StatusDeleted: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="timeline/status-deleted" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12.1421356,2.14213562 C6.61899538,2.14213562 2.14213562,6.61899538 2.14213562,12.1421356 C2.14213562,17.6644727 6.61899538,22.1421356 12.1421356,22.1421356 C17.6644727,22.1421356 22.1421356,17.6644727 22.1421356,12.1421356 C22.1421356,6.61899538 17.6644727,2.14213562 12.1421356,2.14213562 Z M8.6389441,17.0908045 C8.23972716,17.4900215 7.59268369,17.4900215 7.1942498,17.0908045 C6.79503285,16.6915876 6.79503285,16.0445441 7.1942498,15.6453271 L15.6442631,7.19531387 C16.04348,6.79609692 16.6905235,6.79609692 17.0889574,7.19531387 C17.4881743,7.59453081 17.4881743,8.24157428 17.0889574,8.64079123 L8.6389441,17.0908045 Z"
        id="Shape-Copy"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(12.142136, 12.142136) rotate(-315.000000) translate(-12.142136, -12.142136) "
      ></path>
    </g>
  </svg>
);
